import {
  BookOpen,
  Bot,
  Boxes,
  Cable,
  ChevronsLeft,
  Circle,
  FileText,
  GraduationCap,
  KeyRound,
  LayoutDashboard,
  Lightbulb,
  LogOut,
  ScrollText,
  Settings,
  ShieldCheck,
  Square,
  Truck,
  Upload,
  UserCog,
  Users,
  Wrench,
} from 'lucide-react';

/**
 * Single source of truth for sidebar iconography.
 *
 * Replaces the legacy mix of @Assets SVGs, FontAwesome icons, and one-off
 * lucide imports. Mapping is from the *semantic* label used in the menu
 * builders, not the legacy variable name — that way the menu builders read
 * intentionally instead of like the old code's `svg: dashboard_icon`.
 */
export const SidebarIcons = {
  agent: Bot,
  admin: UserCog,
  collapse: ChevronsLeft,
  configuration: Settings,
  credentials: KeyRound,
  dashboard: LayoutDashboard,
  documentation: BookOpen,
  file: FileText,
  insights: Lightbulb,
  integrations: Cable,
  logout: LogOut,
  manualUpload: Upload,
  mfa: ShieldCheck,
  policies: ScrollText,
  policyCpfr: Circle,
  policyOther: Square,
  suppliers: Truck,
  toolkit: Boxes,
  tools: Wrench,
  trainingVideos: GraduationCap,
  users: Users,
} as const;

export type SidebarIconName = keyof typeof SidebarIcons;
